<template lang="pug">
  .center-element
    modal(name="guide-timesheet", :height="615", :width="1300", :scrollable="true", :adaptive="true", @before-close="handleClose")
      //- .to-click.icon-ptt-icons-info(@click="print", style="top: 20px; position:absolute; float: right; right: 20px;", title="Imprimir")

      div(style="padding: 10px;")
        div(ref="printable")
          h3.center-element.color-primary.title(style="grid-column-start: 1; grid-column-end: 3") Teclas de atalho

          table.guide-table.fixed-table
            thead
              tr
                td
                  h4 Atalho
                td
                  h4 Ação
                td
                  h4 Atalho
                td
                  h4 Ação
            tbody
              tr
                td Shift + R
                td Processar os apontamentos dos dias selecionados
                td Shift + A
                td Ir para os apontamentos do mês
              tr
                td Ctrl + P
                td Realiza a correção de pontos
                td Shift + Z
                td Desselecionar todos os dias
              tr
                td(style="display: flex; align-items: center; justify-content: center;") Shift + X ou Shift +&nbsp;
                  .icon-ptt-icons-cima
                  | &nbsp;ou Shift +
                  .icon-ptt-icons-baixo
                td Selecionar o dia atual
                td E
                td Ir para o próximo {{ $ws('employee') }}
              tr
                td Ctrl + Shift + J
                td Mostrar tela de pesquisa de jornada
                td Q
                td Ir para o {{ $ws('employee') }} anterior
              tr
                td Shift + M
                td Adicionar uma suspensão ao dia
                td Shift + Y
                td Adicionar uma nota ao dia
              tr
                td Shift + D ou Shift + S
                td Adicionar justificativa (Dispensa ou Suspensão)
                td Shift + I
                td Adicionar uma observação ao dia
              tr
                td Delete
                td Anular o ponto
                td Shift + O
                td Opções do dia
              tr
                td(style="display: flex; align-items: center; justify-content: center;") Ctrl + &nbsp;
                  .icon-ptt-icons-esquerda.fs-11
                td Ir para o dia ou mês anterior
                td I
                td Exibe informações, imagem e áudio do ponto
              tr
                td(style="display: flex; align-items: center; justify-content: center;") Ctrl + &nbsp;
                  .icon-ptt-icons-direita.fs-11
                td Ir para o próximo dia ou mês
                td Shift + Enter
                td Adicionar mais um ponto do mesmo tipo
              tr
                td Shift + C
                td Alterar {{ $wp('company') }} selecionados
                td Shift + J
                td Alterar jornada utilizando o código
              tr
                td Shift + E
                td Alterar {{ $wp('employee') }} selecionados
                td Shift + F
                td Voltar para o topo da lista selecionada
              tr
                td Shift + B
                td Fazer busca
                td Shift + Q
                td Alterar a ordem dos {{ $ws('employee') }} (nome ou código)
              tr
                td Shift + T
                td Alterar tipo de visualização por local (dia do {{ $ws('company') }} ou folha do {{ $wp('employee') }})
                td J
                td Juntar jornadas dos dias selecionados
              tr
                td M
                td Adicionar o motivo da correção do ponto
                td Shift + P
                td Processar todos os apontamentos
              tr
                td G
                td Exibe a localização do ponto no mapa
                td Shift + G
                td Exibe a localização de todos os pontos do dia
              tr
                td (Macbook) Fn + Delete
                td Deleta Marcação
                td Shift + K
                td Adicionar um sobreaviso

        table.guide-table
          thead
            tr
              td
                h5(style="margin-bottom: 0") Tipos de ponto
              td
                h5(style="margin-bottom: 0") Tipos de travamento
              td
                h5(style="margin-bottom: 0") Status do Banco de Horas

          tbody.no-border
            tr
              td
                .flexy-container
                  .flexy-item(v-for="item in ptKinds", :key="item.class")
                    .line(:title="item.text", style="text-align: center")
                      .box(:class="item.class") 00:00

              td
                .flexy-container
                  .flexy-item(v-for="locker in lockerKinds")
                    .line(:title="locker.text", style="text-align: center")
                      .box.default(:class="locker.classes", :style="{color: locker.color}" )

              td
                .flexy-container
                  .flexy-item-whb(v-for="whb in whbKinds")
                    .line(:title="whb.text", style="text-align: center")
                      .box(:class="whb.color") 000:00
            tr
              td
              td
              td.button
                PButton(color="info", size="sm", @click="close", v-focus) Fechar

</template>

<script>
import { lockerStates } from 'src/components/Sheets/Sheet/sheetUtils'
import html2canvas from 'html2canvas'

export function printDiv (div) {
  const w = window.open()
  html2canvas(div).then(canvas => {
    w.document.body.appendChild(canvas)
    w.print()
    w.close()
  })
}

export default {
  inject: ['changeFocusToPt'],
  data () {
    return {
      ptKinds: [
        { text: 'Ponto registrado por aplicativo, computador ou telefone', 'class': 'default' },
        { text: 'Ponto registrado manualmente', 'class': 'fake-point' },
        { text: 'Ponto manual subtituido por um ponto real', 'class': 'replace_fk' },
        { text: 'Pontos registrados pela correção automatica', 'class': 'auto-correct' },
        { text: 'Pontos registrados com o auto-completar', 'class': 'auto-complete' }
      ],
      lockerKinds: lockerStates,
      whbKinds: [
        { text: 'Aprovado', color: 'success-whb' },
        { text: 'Não aprovado', color: 'danger-whb' },
        { text: 'Expirado', color: 'warning-whb' }
      ]
    }
  },
  computed: {
    compMan () {
      return this.$store.state.userInfo.compMan
    }
  },
  methods: {
    close () {
      this.$modal.hide('guide-timesheet')
    },
    handleClose () {
      this.changeFocusToPt([0, 0], null, true)
    },
    print () {
      return printDiv(this.$refs.printable)
    }
  }
}
</script>

<style scoped>
.fixed-table {
  table-layout: fixed;
}

.title {
  margin: 0;
}

.center-element {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.auto-correct { color: #862a93; }

.fake-point {
  color: #0c9b73
}

.paper-point {
  color: saddlebrown;
}

.afd-point {
  color: #00bcd4;
}

.auto-complete {
  color: #4f47ff;
  /*color: #00a2b5;*/
}

.replace_fk {
  color: #b18d3b;
}
.modal {
  height: 500px;
}

.guide-table {
  width: 100%;
  font-size: 13px;
  text-align: center;
}
@media print {
  @page {size: landscape}
}
.guide-table .no-border td {
  border-bottom: 0;
}
.guide-table td {
  border-bottom: 1px solid #7e7e7e;
}
.button {
  padding-top: 10px;
  text-align: right;
}

.flexy-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-end;
  align-content: center;
}
.flexy-item {
  /* flex: 0 1 auto; */
  width: 10%;
}
.flexy-item-whb {
  /* flex: 0 1 auto; */
  width: 20%;
}
.line {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px;
}
.box {
  font-size: 11px !important;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 3px 5px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  border: 1px solid var(--color-default);
}
.default {
  color: var(--color-default);
}
.warning {
  color: var(--color-warning);
}
.success {
    color: var(--color-success);
}
.success-whb {
  background-color: var(--color-success);
  border: 2px solid var(--color-success);
  color: white;
}
.danger-whb {
  background-color: var(--color-danger);
  border: 2px solid var(--color-danger);
  color: white;
}
.warning-whb {
  background-color: var(--color-warning);
  border: 2px solid var(--color-warning);
  color: white;
}
</style>
